export default {
  headers: [
    {
      id: 'mobileHeader',
      logo: {
        alt: 'logo',
        src: 'https://si-homelight.s3.amazonaws.com/sites/otok/logo.png',
        url: '',
      },
      breakpoint: 1000,
      desktopMenu: {
        type: 'default', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: false,
          reverseOrder: false,
          containerClassName: '',
          imageClassName: '',
        },
        headerClassName: '',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: '',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [],
      },
      mobileMenu: {
        logo: {
          show: false,
          containerClassName: '',
          imageClassName: '',
        },
        type: 'mobile-default', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          type: 'hamburger',
          className: '',
          hide: true,
          reverse: false,
        },
        headerClassName: 'on-brijun-mobile-header-top',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        mobileMenuClassName: '',
        itemClassName: 'on-brijun-mobile-top-item',
        menuClassName: '',
        menuLabelActiveClassName: '',
        menuItemClassName: '',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [
          {
            id: 'login-item',
            content: 'Login / Register',
            url: 'https://www.danaandjeffestates.com/property-search/property-tracker/',
            className: 'on-brijun-special-item',
          },
          {
            id: 'blog-item',
            content: 'Blog',
            url: 'https://www.danaandjeffestates.com/blog/',
            className: 'on-brijun-special-item',
          },
          {
            id: 'phone-item',
            content: ' (747) 888-0508',
            url: 'tel:+17478880508',
            className: 'on-brijun-special-item phone',
          },
        ],
        items: [],
      },
    },
    {
      id: 'mainHeader',
      logo: {
        alt: 'logo',
        src: 'https://si-homelight.s3.amazonaws.com/sites/brijun/logo.png',
        url: 'https://www.danaandjeffestates.com/',
      },
      breakpoint: 1000,
      desktopMenu: {
        type: 'center', // default, split, center, single, one-offs
        disableOnHoverMenuExpand: false,
        logo: {
          show: true,
          reverseOrder: false,
          containerClassName: 'on-brijun-desktop-logo-c',
          imageClassName: 'on-brijun-desktop-logo',
        },
        headerClassName: 'on-brijun-desktop-header',
        headerSectionsClassName: 'on-brijun-desktop-header-sections',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        itemClassName: 'on-brijun-desktop-item',
        menuClassName: 'on-brijun-desktop-menu',
        menuLabelActiveClassName: 'on-brijun-desktop-label',
        menuItemClassName: 'on-brijun-desktop-menu-item',
        subMenuClassName: '',
        subMenuLabelActiveClassName: 'on-brijun-desktop-sub-label',
        subMenuItemClassName: 'on-brijun-desktop-sub-menu-item',
        items: [
          {
            id: 'team-item',
            content: 'Team',
            url: 'https://www.danaandjeffestates.com/about/',
          },
          {
            id: 'search-item',
            content: 'Search',
            menuItems: [
              {
                id: 'search-item-advanced',
                content: 'Advanced Search',
                url: 'https://www.danaandjeffestates.com/property-search/search-form/',
              },
              {
                id: 'search-item-map',
                content: 'Search by Map',
                url: 'https://www.danaandjeffestates.com/property-search/results/?searchtype=3',
              },
              {
                id: 'search-item-property-tracker',
                content: 'Property Tracker',
                url: 'https://www.danaandjeffestates.com/property-search/property-tracker/',
              },
              {
                id: 'search-item-featured-listings',
                content: 'Featured Listings',
                url: 'https://www.danaandjeffestates.com/featured-listings/',
              },
              {
                id: 'search-item-sold-listings',
                content: 'Sold Listings',
                url: 'https://www.danaandjeffluxuryhomes.com/properties/sold',
              },
            ],
          },
          {
            id: 'cities-search-item',
            content: 'Cities',
            url: 'https://www.danaandjeffestates.com/cities/',
          },
          {
            id: 'communities-item',
            content: 'Communities',
            url: 'https://www.danaandjeffestates.com/communities/',
          },
          {
            id: 'menu-item',
            content: 'More',
            menuItems: [
              {
                id: 'menu-item-home',
                content: 'Home',
                url: 'https://www.danaandjeffestates.com/',
              },
              {
                id: 'menu-item-contact',
                content: 'Contact',
                url: 'https://www.danaandjeffestates.com/contact/',
              },
              {
                id: 'menu-item-schools',
                content: 'Schools',
                url: 'https://www.danaandjeffestates.com/schools/',
              },
              {
                id: 'menu-item-houses',
                content: 'Open Houses',
                menuItems: [
                  {
                    id: 'menu-item-houses-dana-jeff',
                    content: 'DANA+JEFF OPEN THIS WEEKEND',
                    url: 'https://www.danaandjeffestates.com/open-houses/dana-jeff-open-houses/',
                  },
                  {
                    id: 'menu-item-houses-open',
                    content: 'OPEN HOUSES THIS WEEKEND',
                    url: 'https://www.danaandjeffestates.com/open-houses/open-houses/',
                  },
                ],
              },
              {
                id: 'menu-item-developements',
                content: 'New Developments',
                url: 'https://www.danaandjeffestates.com/new-developments/thependry/',
              },
              {
                id: 'menu-item-buyers',
                content: 'Buyers',
                menuItems: [
                  {
                    id: 'menu-item-buyers-calculator',
                    content: 'Mortgage Calculator',
                    url: 'https://www.danaandjeffestates.com/buyers/mortgage-calculator/',
                  },
                  {
                    id: 'menu-item-buyers-mortgage',
                    content: 'Mortgage Pre-Approval',
                    url: 'https://www.danaandjeffestates.com/buyers/mortgage-pre-approval/',
                  },
                  {
                    id: 'menu-item-buyers-personalized',
                    content: 'Personalized Home Search',
                    url: 'https://www.danaandjeffestates.com/buyers/personalized-home-search/',
                  },
                  {
                    id: 'menu-item-buyers-cohen',
                    content: 'Cohen Financial Group',
                    url: 'https://www.danaandjeffestates.com/buyers/cohen-financial-group/',
                  },
                  {
                    id: 'menu-item-buyers-compass',
                    content: 'Compass Bridge Loan',
                    url: 'https://www.danaandjeffestates.com/buyers/compass-bridge-loan/',
                  },
                  {
                    id: 'menu-item-buyers-soon',
                    content: 'Coming-Soon',
                    url: 'https://www.danaandjeffestates.com/buyers/coming-soon/',
                  },
                ],
              },
              {
                id: 'menu-item-sellers',
                content: 'Sellers',
                url: 'https://www.danaandjeffestates.com/sellers/',
              },
              {
                id: 'menu-item-buy-before-sell',
                content: 'Buy Before You Sell',
                url: 'https://cash-offer-brijun.netlify.app/',
              },
              {
                id: 'menu-item-become-all-cash',
                content: 'Become an All-cash Buyer',
                url: 'https://trade-in-brijun.netlify.app/',
              },
              {
                id: 'menu-item-soon',
                content: 'Cooming Soon Program',
                url: 'https://www.danaandjeffestates.com/coming-soon-listings/',
              },
            ],
          },
          {
            id: 'login-item',
            content: 'Login / Register',
            url: 'https://www.danaandjeffestates.com/property-search/property-tracker/',
            className: 'on-brijun-special-item',
          },
          {
            id: 'blog-item',
            content: 'Blog',
            url: 'https://www.danaandjeffestates.com/blog/',
            className: 'on-brijun-special-item',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: true,
          containerClassName: '',
          imageClassName: 'on-brijun-mobile-logo',
        },
        type: 'mobile-default', // mobile-default, mobile-reversed, mobile-center
        menuOpener: {
          type: 'hamburger',
          className: '',
          hide: false,
          reverse: false,
        },
        headerClassName: 'on-brijun-mobile-header',
        headerSectionsClassName: '',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '',
        mobileMenuClassName: 'on-brijun-mobile-menu',
        itemClassName: 'on-brijun-mobile-item',
        menuClassName: 'on-brijun-mobile-folder',
        menuLabelActiveClassName: '',
        menuItemClassName: 'on-brijun-mobile-folder-item',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [],
        items: [
          {
            id: 'home-menu-item',
            content: 'Home',
            url: 'https://www.danaandjeffestates.com/',
          },
          {
            id: 'blog-menu-item',
            content: 'Blog',
            url: 'https://www.danaandjeffestates.com/blog/',
          },
          {
            id: 'team-menu-item',
            content: 'Team',
            url: 'https://www.danaandjeffestates.com/about/',
          },
          {
            id: 'search-menu-item',
            content: 'Search',
            menuItems: [
              {
                id: 'search-menu-item-advanced',
                content: 'Advanced Search',
                url: 'https://www.danaandjeffestates.com/property-search/search-form/',
              },
              {
                id: 'search-menu-item-map',
                content: 'Search by Map',
                url: 'https://www.danaandjeffestates.com/property-search/results/?searchtype=3',
              },
              {
                id: 'search-menu-item-property-tracker',
                content: 'Property Tracker',
                url: 'https://www.danaandjeffestates.com/property-search/property-tracker/',
              },
              {
                id: 'search-menu-item-featured-listings',
                content: 'Featured Listings',
                url: 'https://www.danaandjeffestates.com/featured-listings/',
              },
              {
                id: 'search-menu-item-sold-listings',
                content: 'Sold Listings',
                url: 'https://www.danaandjeffluxuryhomes.com/properties/sold',
              },
            ],
          },
          {
            id: 'cities-menu-item',
            content: 'Cities',
            url: 'https://www.danaandjeffestates.com/cities/',
          },
          {
            id: 'communities-item',
            content: 'Communities',
            url: 'https://www.danaandjeffestates.com/communities/',
          },
          {
            id: 'coming-soon-item',
            content: 'Coming Soon Program',
            url: 'https://www.danaandjeffestates.com/coming-soon-listings/',
          },
          {
            id: 'contact-item',
            content: 'Contact',
            url: 'https://www.danaandjeffestates.com/contact/',
          },
          {
            id: 'schools-item',
            content: 'Schools',
            url: 'https://www.danaandjeffestates.com/schools/',
          },
          {
            id: 'open-houses-item',
            content: 'Open Houses',
            menuItems: [
              {
                id: 'open-houses-one',
                content: 'DANA+JEFF OPEN THIS WEEKEND',
                url: 'https://www.danaandjeffestates.com/open-houses/dana-jeff-open-houses/',
              },
              {
                id: 'open-houses-two',
                content: 'OPEN HOUSES THIS WEEKEND',
                url: 'https://www.danaandjeffestates.com/open-houses/open-houses/',
              },
            ],
          },
          {
            id: 'new-developments-item',
            content: 'New Developments',
            url: 'https://www.danaandjeffestates.com/new-developments/thependry/',
          },
          {
            id: 'buyers-item',
            content: 'Buyers',
            menuItems: [
              {
                id: 'calc-item',
                content: 'Mortgage Calculator',
                url: 'https://www.danaandjeffestates.com/buyers/mortgage-calculator/',
              },
              {
                id: 'pre-approval-item',
                content: 'Mortgage Pre-Approval',
                url: 'https://www.danaandjeffestates.com/buyers/mortgage-pre-approval/',
              },
              {
                id: 'personalized-search-item',
                content: 'Personalized Home Search',
                url: 'https://www.danaandjeffestates.com/buyers/personalized-home-search/',
              },
              {
                id: 'cohen-item',
                content: 'Cohen Financial Group',
                url: 'https://www.danaandjeffestates.com/buyers/cohen-financial-group/',
              },
              {
                id: 'compass-item',
                content: 'Compass Bridge Loan',
                url: 'https://www.danaandjeffestates.com/buyers/compass-bridge-loan/',
              },
              {
                id: 'coming-soon-item',
                content: 'Coming-Soon',
                url: 'https://www.danaandjeffestates.com/buyers/coming-soon/',
              },
            ],
          },
          {
            id: 'sellers-item',
            content: 'Sellers',
            url: 'https://www.danaandjeffestates.com/sellers/',
          },
          {
            id: 'menu-item-buy-before-sell',
            content: 'Buy Before You Sell',
            url: 'https://cash-offer-brijun.netlify.app/',
          },
          {
            id: 'menu-item-become-all-cash',
            content: 'Become an All-cash Buyer',
            url: 'https://trade-in-brijun.netlify.app/',
          },
        ],
      },
    },
  ],
  footers: [
    {
      id: 'on-brijun-footer-first',
      display: true,
      className: 'on-brijun-footer-section-one',
      sectionClassName: 'on-brijun-footer-section-container',
      columns: [
        {
          id: 'f-1-col-1',
          className: 'align-center on-brijun-footer-img-container',
          style: {},
          items: [
            {
              id: 'f-1-col-1-img',
              type: 'image',
              className: 'on-brijun-footer-image',
              style: { width: '280px', backgroundColor: 'white' },
              linkUrl: 'https://www.danaandjeffestates.com/',
              url: 'https://si-homelight.s3.amazonaws.com/sites/brijun/logo.png',
            },
          ],
        },
      ],
    },

    {
      id: 'on-brijun-footer-second',
      display: true,
      className: 'on-brijun-footer-section-two',
      sectionClassName: 'on-brijun-footer-section-container',
      columns: [
        {
          id: 'f-2-col-1',
          className: 'on-brijun-footer-column col-md-3 col-sm-12',
          style: {},
          items: [
            {
              id: 'f-2-col-1-h1',
              type: 'heading',
              elementType: 'h1',
              className: '',
              style: {},
              data: 'CONTACT',
            },
            {
              id: 'f-2-col-1-item-1',
              type: 'heading',
              elementType: 'p',
              className: '',
              style: {},
              data: 'Frontgate Real Estate| Dana Olmes & Jeff Biebuyck Group',
            },
            {
              id: 'f-2-col-1-item-2',
              type: 'heading',
              elementType: 'p',
              className: 'mb-0',
              style: {},
              data: '23500 Long Valley Rd',
            },
            {
              id: 'f-2-col-1-item-3',
              type: 'heading',
              elementType: 'p',
              className: 'mb-0',
              style: {},
              data: 'Hidden Hills, CA 91302',
            },
            {
              id: 'f-2-col-1-item-4',
              type: 'itemContent',
              className: 'mb-0',
              style: {},
              items: [
                {
                  content: 'M: ',
                },
                {
                  content: '(747) 210-9657',
                  url: 'tel:(747) 210-9657',
                  className: 'on-brijun-phone-link',
                },
              ],
            },
            {
              id: 'f-2-col-1-item-5',
              type: 'itemContent',
              className: 'mb-0',
              style: {},
              items: [
                {
                  content: 'E: ',
                },
                {
                  content: 'Email Us',
                  url: 'mailto:contact@danaandjeffestates.com',
                  className: 'on-brijun-email-link',
                },
              ],
            },
            {
              id: 'f-2-col-1-item-6',
              type: 'heading',
              elementType: 'p',
              className: 'mb-0',
              style: {},
              data: 'Dana Olmes | DRE# 00944676',
            },
            {
              id: 'f-2-col-1-item-7',
              type: 'heading',
              elementType: 'p',
              className: 'mb-0',
              style: {},
              data: 'Jeff Biebuyck | DRE# 01383921',
            },
          ],
        },
        {
          id: 'f-col-2',
          className: 'on-brijun-footer-column col-md-3 col-sm-12',
          style: {},
          items: [
            {
              id: 'col-two-heading',
              type: 'heading',
              elementType: 'h1',
              className: '',
              style: {},
              data: 'CONNECT',
            },
            {
              id: 'col-two-socials',
              type: 'socialIcons',
              className: 'on-brijun-footer-socials',
              style: {},
              items: [
                {
                  id: 'on-brijun-fcb',
                  iconTypeClassName: 'fab',
                  iconClassName: 'facebook-f',
                  data: 'Facebook',
                  className: 'fbb',
                  url: 'https://www.facebook.com/DanaAndJeff/',
                },
                {
                  id: 'on-brijun-insta',
                  iconTypeClassName: 'fab',
                  iconClassName: 'instagram',
                  data: 'Instagram',
                  url: 'https://www.instagram.com/danaandjeff/',
                },
                {
                  id: 'on-brijun-yt',
                  iconTypeClassName: 'fab',
                  iconClassName: 'youtube',
                  data: 'Youtube',
                  url: 'https://www.youtube.com/channel/UCyi2N_0tV7gu3AM0Vm-aQxA',
                },
              ],
            },
          ],
        },
        {
          id: 'col-three',
          className: 'on-brijun-footer-column  col-md-3 col-sm-12',
          style: {},
          items: [
            {
              id: 'col-three-heading',
              type: 'heading',
              elementType: 'h1',
              className: '',
              style: {},
              data: 'NAVIGATION',
            },
            {
              id: 'col-three-menu',
              type: 'menu',
              className: 'on-brijun-footer-menu',
              itemClassName: 'mb-0',
              style: {},
              items: [
                {
                  id: 'col-three-item-1',
                  data: 'Team',
                  url: 'https://www.danaandjeffestates.com/about/',
                },
                {
                  id: 'col-three-item-2',
                  data: 'Search',
                  url: 'https://www.danaandjeffestates.com/property-search/search-form/',
                },
                {
                  id: 'col-three-item-3',
                  data: 'Cities',
                  url: 'https://www.danaandjeffestates.com/cities/',
                },
                {
                  id: 'col-three-item-4',
                  data: 'Communities',
                  url: 'https://www.danaandjeffestates.com/communities/',
                },
                {
                  id: 'col-three-item-5',
                  data: 'Coming Soon Program',
                  url: 'https://www.danaandjeffestates.com/coming-soon-listings/',
                },
                {
                  id: 'col-three-item-6',
                  data: 'Contact',
                  url: 'https://www.danaandjeffestates.com/contact/',
                },
                {
                  id: 'col-three-item-7',
                  data: 'Schools',
                  url: 'https://www.danaandjeffestates.com/schools/',
                },
                {
                  id: 'col-three-item-8',
                  data: 'Open Houses',
                  url: 'https://www.danaandjeffestates.com/open-houses/dana-jeff-open-houses/',
                },
                {
                  id: 'col-three-item-9',
                  data: 'New Developments',
                  url: 'https://www.danaandjeffestates.com/new-developments/thependry/',
                },
                {
                  id: 'col-three-item-10',
                  data: 'View All',
                  url: 'https://www.danaandjeffestates.com/#',
                },
              ],
            },
          ],
        },
        {
          id: 'col-four',
          className: 'on-brijun-footer-column col-md-3 col-sm-12',
          style: {},
          items: [
            {
              id: 'col-four-h1',
              type: 'heading',
              elementType: 'h1',
              className: '',
              style: {},
              data: 'POPULAR SEARCHES',
            },
            {
              id: 'col-four-menu',
              type: 'menu',
              className: 'on-brijun-footer-menu',
              itemClassName: 'mb-0',
              style: {},
              items: [
                {
                  id: 'col-four-item-1',
                  data: 'Featured Listings',
                  url: 'https://www.danaandjeffestates.com/featured-listings/',
                },
                {
                  id: 'col-four-item-2',
                  data: 'Single Family Homes',
                  url: 'https://www.danaandjeffestates.com/property-search/results/?searchid=239855',
                },
                {
                  id: 'col-four-item-3',
                  data: 'Condos & Townhomes',
                  url: 'https://www.danaandjeffestates.com/property-search/results/?searchid=239728',
                },
                {
                  id: 'col-four-item-4',
                  data: 'New Construction',
                  url: 'https://www.danaandjeffestates.com/property-search/results/?searchid=239845',
                },
                {
                  id: 'col-four-item-5',
                  data: 'Gated Community',
                  url: 'https://www.danaandjeffestates.com/property-search/results/?searchid=239734',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'on-brijun-footer-third',
      display: true,
      className: 'on-brijun-footer-section-three',
      sectionClassName: 'on-brijun-footer-section-container',
      columns: [
        {
          id: 'f-3-col-1',
          className: 'col-lg-6',
          style: {},
          items: [
            {
              id: 'f-3-col-1-item-1',
              type: 'menu',
              className: 'on-brijun-footer-privacy-menu',
              style: {},
              items: [
                {
                  id: 'f-3-col-1-menu-1',
                  data: 'Accessibility',
                  className: 'on-brijun-footer-privacy-menu-item-first',
                  url: 'https://www.danaandjeffestates.com/accessibility/',
                },
                {
                  id: 'f-3-l-1',
                  data: '|',
                },
                {
                  id: 'f-3-col-1-menu-2',
                  data: 'Terms of Service',
                  url: 'https://www.danaandjeffestates.com/terms-of-service/',
                },
                {
                  id: 'f-3-l-2',
                  data: '|',
                },
                {
                  id: 'f-3-col-1-menu-3',
                  data: 'Privacy Policy',
                  url: 'https://www.danaandjeffestates.com/privacy-policy/',
                },
                {
                  id: 'f-3-l-3',
                  data: '|',
                },
                {
                  id: 'f-3-col-1-menu-4',
                  data: 'DMCA Notice',
                  url: 'https://www.danaandjeffestates.com/dmca-notice/',
                },
                {
                  id: 'f-3-l-4',
                  data: '|',
                },
                {
                  id: 'f-3-col-1-menu-5',
                  data: 'Property Listings',
                  url: 'https://www.danaandjeffestates.com/property-search/site-map/',
                },
                {
                  id: 'f-3-l-5',
                  data: '|',
                },
                {
                  id: 'f-3-col-1-menu-6',
                  data: 'Sitemap',
                  url: 'https://www.danaandjeffestates.com/site-map/',
                },
              ],
            },
            {
              id: 'f-3-col-1-item-2',
              type: 'heading',
              className: '',
              style: {},
              data: '© Copyright 2022 Dana & Jeff Luxury Homes Team. All Rights Reserved.',
            },
          ],
        },
        {
          id: 'f-3-col-2',
          className: 'col-lg-6',
          style: {},
          items: [
            {
              id: 'f-3-col-2-item-1',
              type: 'image',
              className: 'on-brijun-footer-realtor-logo',
              url: 'https://si-homelight.s3.amazonaws.com/sites/iz/logo-footer-equal-realtor.png',
            },
          ],
        },
      ],
    },
  ],
  substitute: {},
  replace: {
    'tradeIn.hero.className': 'heroClassName',
    'cashOffer.hero.className': 'heroClassName',
  },
  siteData: {
    agency: 'Frontgate Real Estate',
    agentDescription: 'Top agents in Greater Los Angeles Area',
    agentAvatar: 'https://si-homelight.s3.amazonaws.com/sites/brijun/agent.jpg',
    heroBackground: 'https://si-homelight.s3.amazonaws.com/sites/brijun/hero-bg.jpg',
    heroClassName: 'on-brijun-hero',
  },
};
